export default "__VITE_ASSET__6b9ae6fa__"